import classNames from 'classnames';
import styles from './header.module.css';
import { Nav } from './nav/nav';
import { selectCartITems } from '../cart/cart.slice';
import { useAppSelector } from '../app/hooks';
import { selectFavourites } from '../slider/favourites.slice';
import { useGetSettingsQuery } from '../app/api/api';

export const Header = () => {
  const cartItems = useAppSelector(selectCartITems);
  const favourites = useAppSelector(selectFavourites);
  const { data: settings } = useGetSettingsQuery();
  return (
    <header
      className={classNames(styles.header, {
        [styles.withShoppingCart]:
          cartItems.length > 0 && favourites.length === 0,
        [styles.withFavourites]:
          favourites.length > 0 && cartItems.length === 0,
        [styles.withShippingAndFavourites]:
          favourites.length > 0 && cartItems.length > 0,
      })}
    >
      <a className={styles.logo} href={settings?.logoLink || '/'}>
        {settings?.logoUrl ? (
          settings?.separateLightDarkLogo && settings?.logoLightUrl ? (
            <picture>
              <source
                srcSet={settings.logoLightUrl}
                media="(prefers-color-scheme: light)"
              />
              <img src={settings.logoUrl} alt={settings.accountName || ''} />
            </picture>
          ) : (
            <img src={settings.logoUrl} alt={settings.accountName || ''} />
          )
        ) : (
          <span className={styles.logoText}>
            {settings?.accountName || ''}
          </span>
        )}
      </a>
      <Nav />
    </header>
  );
};
